import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tag",
  "use": "icon-tag-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"icon-tag\"><defs><style>#icon-tag .cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px;}</style></defs><title></title><polyline class=\"cls-1\" points=\"55.56 10.12 9.81 55.88 44.12 90.19 89.88 44.44\" /><polyline class=\"cls-1\" points=\"90.19 43.83 86.12 13.88 56.17 9.81\" /><circle class=\"cls-1\" cx=\"68.56\" cy=\"31.44\" r=\"6.51\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol